import { useLocale } from '@/providers/LocaleProvider';
import { Theme } from 'klayowebshared';
import { CourseDetails } from '../my-klayo/CourseDetails';

type Props = {
  theme: typeof Theme;
};

const TrainingCourseDetail = (props: Props) => {
  const { translate } = useLocale();
  return (
    <CourseDetails
      theme={props.theme}
      title={translate('settingsNav.training')}
      isTrainingManager={true}
    />
  );
};

export { TrainingCourseDetail };
